import React, { useEffect } from "react"
import { Box, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { PeopleAlt } from "@material-ui/icons"
import { useSnackbar } from "../../utils/notificacoes"
import Cabecalho from "../Cabecalho"
import { FiltrosClientes } from "./components/FiltrosClientes"
import { TabelaClientes } from "./components/TabelaClientes"
import { useClientesFornecedorContext } from "./context/useClientesFornecedorContext"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: { paddingLeft: "20px", paddingRight: "20px", paddingTop: "80px" },
        [theme.breakpoints.down("sm")]: { paddingLeft: "15px", paddingRight: "15px", paddingTop: "70px" },
    },
    content: {
        margin: "auto",
        maxWidth: "1100px",
        [theme.breakpoints.down("sm")]: { maxWidth: "100%" },
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(1),
    },
    iconHeader: {
        color: "#4caf50",
        marginRight: theme.spacing(1),
        fontSize: "2rem",
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: { fontSize: "1.5rem" },
        [theme.breakpoints.down("xs")]: { fontSize: "1.25rem" },
    },
    subtitleText: {
        color: "#7f8c8d",
        marginBottom: theme.spacing(3),
    },
}))

export function ClientesFornecedor() {
    const classes = useStyles()
    const { erroCarregamento } = useClientesFornecedorContext()
    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        if (erroCarregamento) {
            enqueueSnackbar(erroCarregamento, { variant: "error" })
        }
    }, [erroCarregamento])

    return (
        <>
            <Cabecalho pagina="Clientes" />
            <Box className={classes.container}>
                <Box className={classes.content}>
                    <Box className={classes.titleRow}>
                        <PeopleAlt className={classes.iconHeader} />
                        <Typography variant="h5" className={classes.titleText}>
                            Clientes do Estabelecimento
                        </Typography>
                    </Box>
                    <Typography variant="body2" className={classes.subtitleText}>
                        Aqui você pode filtrar e visualizar seus clientes.
                    </Typography>

                    <FiltrosClientes />
                    <TabelaClientes />
                </Box>
            </Box>
        </>
    )
}
